/**
 * Two-step disconnect for every integration.
 *
 * Disconnecting drops live credentials and webhooks, and re-connecting is a full OAuth or
 * key flow again, so a single menu click must never do it. `confirmDisconnect(platform)`
 * resolves true only when the user confirms in the dialog rendered by `DisconnectConfirmHost`
 * (disconnect-confirm.tsx), which is mounted once at the sheet root — outside any dropdown
 * menu, since Radix unmounts menu content (and anything inside it) the moment the menu closes.
 */
export interface PendingDisconnectConfirm {
	platform: string;
	resolve: (confirmed: boolean) => void;
}

let listener: ((pending: PendingDisconnectConfirm) => void) | null = null;

/** Registered by the host while mounted. */
export const setDisconnectConfirmListener = (next: typeof listener) => {
	listener = next;
};

export const confirmDisconnect = (platform: string): Promise<boolean> =>
	new Promise((resolve) => {
		if (!listener) {
			// No host mounted: fail closed rather than disconnect without asking.
			resolve(false);
			return;
		}
		listener({ platform, resolve });
	});
